export function hasRichText(value = "") {
  return /<[^>]+>/.test(String(value || ""));
}

function normalizeText(value = "") {
  return String(value || "").replace(/\u00a0/g, " ").replace(/\s+/g, " ").trim();
}

function decodeHtmlEntities(value = "") {
  const text = String(value || "");
  if (typeof window === "undefined") {
    return text
      .replace(/&nbsp;|&#160;|&#xa0;/gi, " ")
      .replace(/&amp;/gi, "&")
      .replace(/&lt;/gi, "<")
      .replace(/&gt;/gi, ">")
      .replace(/&quot;/gi, '"')
      .replace(/&#039;|&#39;|&apos;/gi, "'")
      .replace(/&#x([0-9a-f]+);/gi, (_, hex) => String.fromCodePoint(parseInt(hex, 16)))
      .replace(/&#(\d+);/g, (_, num) => String.fromCodePoint(parseInt(num, 10)));
  }

  const element = document.createElement("textarea");
  element.innerHTML = text;
  return element.value;
}

export function stripHtml(value = "") {
  const decoded = decodeHtmlEntities(decodeHtmlEntities(value));
  if (typeof window === "undefined") {
    return normalizeText(decoded.replace(/<[^>]*>/g, " "));
  }
  const element = document.createElement("div");
  element.innerHTML = decoded;
  return normalizeText(element.textContent || element.innerText || "");
}
export function RichText({ value, as: Tag = "span", className = "" }) {
  return <Tag className={className}>{stripHtml(value)}</Tag>;
}